var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("出库管理")]),
            ]),
            _vm.juadg != "page"
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { path: "/notInStock" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("未备货订单")])]
                )
              : _vm._e(),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("订单详情")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(0),
    _c(
      "div",
      { staticClass: "orderBox" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("订单商品")]),
        _c(
          "el-table",
          { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
          [
            _c("el-table-column", {
              attrs: { prop: "date", label: "商品名称", width: "500" },
            }),
            _c("el-table-column", {
              attrs: { prop: "name", label: "商品数量", width: "180" },
            }),
            _c("el-table-column", {
              attrs: { prop: "address", label: "商品单价" },
            }),
            _c("el-table-column", {
              attrs: { prop: "address", label: "商品规格" },
            }),
            _c("el-table-column", {
              attrs: { prop: "address", label: "商品小计" },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._m(1),
    _c(
      "div",
      { staticClass: "manipulate" },
      [
        _c("el-button", { attrs: { type: "primary" } }, [_vm._v("发货")]),
        _c("el-button", { attrs: { type: "warning" } }, [_vm._v("驳回订单")]),
      ],
      1
    ),
    _vm.juadg != "page"
      ? _c(
          "div",
          { staticClass: "fix" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { label: "订单修改记录", name: "first" } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%", "margin-top": "20px" },
                        attrs: {
                          data: _vm.tableData1,
                          "span-method": _vm.objectSpanMethod,
                          border: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "id",
                            label: "修改记录",
                            width: "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "name", label: "记录人员" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "amount1", label: "进度时间" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "amount2", label: "审核人员" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "amount3", label: "审核时间" },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "amount3", label: "审核订单" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  { attrs: { label: "物流记录", name: "second" } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.tableData },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "date",
                            label: "物流记录",
                            width: "600",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "记录人员",
                            width: "180",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "address", label: "进度时间" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.juadg == "page"
      ? _c(
          "div",
          { staticClass: "total" },
          [
            _c("el-button", { attrs: { type: "primary" } }, [
              _vm._v("确定改单"),
            ]),
            _c("el-button", { attrs: { type: "primary" } }, [
              _vm._v("提交经理"),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "address" }, [
      _c("p", { staticClass: "header" }, [_vm._v("收货人信息")]),
      _c("ul", [
        _c("li", [
          _c("p", [_vm._v("收货人姓名：张中原")]),
          _c("p", [_vm._v("联系电话：1882516328")]),
          _c("p", [_vm._v("收货地址：广州白云区江夏")]),
        ]),
        _c("li", [_c("p", [_vm._v("详细地址：广州白云区江夏")])]),
        _c("li", [_c("p", [_vm._v("备注：无")])]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "total" }, [
      _c("p", [_vm._v("总计：共 3 件")]),
      _c("p", [_vm._v("运费：0")]),
      _c("p", [_vm._v("总价：1422")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }